import apiClient, { setAuthToken } from './api.client';

const ensureAuth = () => {
  const tk = localStorage.getItem('token');
  if (tk) setAuthToken(tk);
};

const handleError = (err) => {
  if (err?.response?.status === 401) {
    const e = new Error('Unauthorized');
    e.status = 401;
    throw e;
  }
  throw err;
};

const WhatsappService = {
  getStatus: async (accountId) => {
    try {
      ensureAuth();
      const res = await apiClient.get(`/whatsapp/${accountId}/status`);
      return res.data;
    } catch (err) {
      handleError(err);
    }
  },

  getQr: async (accountId) => {
    try {
      ensureAuth();
      const res = await apiClient.get(`/whatsapp/${accountId}/qr`);
      return res.data;
    } catch (err) {
      handleError(err);
    }
  },

  start: async (accountId) => {
    try {
      ensureAuth();
      const res = await apiClient.post(`/whatsapp/${accountId}/start`);
      return res.data;
    } catch (err) {
      handleError(err);
    }
  },

  restart: async (accountId) => {
    try {
      ensureAuth();
      const res = await apiClient.post(`/whatsapp/${accountId}/restart`);
      return res.data;
    } catch (err) {
      handleError(err);
    }
  },

  logout: async (accountId) => {
    try {
      ensureAuth();
      const res = await apiClient.delete(`/whatsapp/${accountId}`);
      return res.data;
    } catch (err) {
      handleError(err);
    }
  },

  sendTest: async (accountId, to, text) => {
    try {
      ensureAuth();
      const res = await apiClient.post(`/whatsapp/${accountId}/test`, { to, text });
      return res.data;
    } catch (err) {
      handleError(err);
    }
  },

  getCloudConfig: async (accountId) => {
    try {
      ensureAuth();
      const res = await apiClient.get(`/whatsapp/${accountId}/cloud`);
      return res.data;
    } catch (err) {
      handleError(err);
    }
  },

  saveCloudConfig: async (accountId, payload) => {
    try {
      ensureAuth();
      const res = await apiClient.put(`/whatsapp/${accountId}/cloud`, payload);
      return res.data;
    } catch (err) {
      handleError(err);
    }
  },

  syncCloud: async (accountId) => {
    try {
      ensureAuth();
      const res = await apiClient.post(`/whatsapp/${accountId}/cloud/sync`);
      return res.data;
    } catch (err) {
      handleError(err);
    }
  },

  getCloudTemplates: async (accountId) => {
    try {
      ensureAuth();
      const res = await apiClient.get(`/whatsapp/${accountId}/cloud/templates`);
      return res.data;
    } catch (err) {
      handleError(err);
    }
  },

  getMessagesReport: async (accountId, params) => {
    try {
      ensureAuth();
      const res = await apiClient.get(`/whatsapp/${accountId}/messages`, { params });
      return res.data;
    } catch (err) {
      handleError(err);
    }
  },
};

export default WhatsappService;
